<template>
	<div class="wrap">
		<div class="page_title"><b>岗位管理</b></div>
		<div class="main public_box">
			<post-admin-hl></post-admin-hl>
		</div>
	</div>
</template>

<script> 
// @ is an alias to /src   
import PostAdminHl from '@/package/postAdminHl/index.vue'
export default {
	name: 'postAdmin',
	components: {
		PostAdminHl
	},
	data(){
		return{
			loading:false,
			menuType:'searchReviewPage'
		}
	},
	methods:{
		
	},
	mounted() {  // 

	}
}
</script>
<style scoped>
	.main{
		margin-top: 0.2rem;
	}
</style>
